import {
  ERROR_COLORS,
  GRAY_COLORS,
  INFO_COLORS,
  PRIMARY_COLORS,
  WARNING_COLORS
} from 'asterX-UI/colors.constant'
import React from 'react'
import { Chip, withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
export const defaultB = '#FFFFFF'
export const primaryB = '#7F56D9'
export const secondaryB = '#E9F2FF'
export const positiveB = '#EDFFF6'
export const negativeB = '#FFE9E9'

export const defaultC = '#94A1B4'
export const primaryC = '#FFFFFF'
export const secondaryC = '#0B6EC7'
export const positiveC = '#4BAB43'
export const negativeC = '#FF4848'

export const darkBlue = '#1E385B'
export const yellow = '#F7D117'
export const purple = '#7F56D9'
export const lightBlue = '#DCEBFF'

export const primaryBHover = '#9869ff'

const styledBy = (property, mapping) => props => mapping[props[property]]

const styles = {
  root: {
    background: styledBy('color', {
      classic: GRAY_COLORS[100],
      blue: INFO_COLORS[100],
      green: positiveC,
      red: negativeC,
      yellow: yellow,
      black: '#2E2E2E'
    }),
    color: styledBy('color', {
      classic: GRAY_COLORS[700],
      blue: INFO_COLORS[700],
      green: primaryC,
      red: primaryC,
      yellow: '#2E2E2E',
      black: primaryC
    }),
    fontSize: '0.75rem',
    padding: 2,

    borderRadius: 16
  },
  classic: {
    backgroundColor: GRAY_COLORS[100],
    color: GRAY_COLORS[700]
  },
  blue: {
    padding: 2,
    backgroundColor: INFO_COLORS[100],
    color: INFO_COLORS[700]
  },
  green: {
    padding: 2,
    backgroundColor: 'rgb(75, 171, 67)',
    color: 'rgb(255, 255, 255)'
  },
  red: {
    padding: 2,
    backgroundColor: ERROR_COLORS[100],
    color: ERROR_COLORS[700]
  },
  yellow: {
    padding: 2,
    backgroundColor: 'rgb(255, 235, 59)',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  orange: {
    padding: 2,
    backgroundColor: WARNING_COLORS[50],
    color: WARNING_COLORS[700]
  },
  black: {
    padding: 2,
    backgroundColor: '#000',
    color: '#fff'
  }
}

const AsterChip = withStyles(styles)(({ classes, className, ...other }) => (
  <Chip
    className={[classes.root, classes[!!className ? className : '']].join(' ')}
    {...other}
  />
))

export default AsterChip

AsterChip.propTypes = {
  color: PropTypes.oneOf([
    'classic',
    'blue',
    'green',
    'red',
    'yellow',
    'black'
  ]),
  label: PropTypes.string
}
